module.exports = __webpack_public_path__ + "fonts/NotoSansKR-Regular.af8df214.woff";